// extracted by mini-css-extract-plugin
export default {"initialMessageTextArea":"CustomStripePaymentForm_initialMessageTextArea__JuX9F","cardHolderName":"CustomStripePaymentForm_cardHolderName__KeJx6"};